import { render, staticRenderFns } from "./r-trader-offer-rule-table.vue?vue&type=template&id=32a34fac"
import script from "./r-trader-offer-rule-table.vue?vue&type=script&lang=js"
export * from "./r-trader-offer-rule-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32a34fac')) {
      api.createRecord('32a34fac', component.options)
    } else {
      api.reload('32a34fac', component.options)
    }
    module.hot.accept("./r-trader-offer-rule-table.vue?vue&type=template&id=32a34fac", function () {
      api.rerender('32a34fac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/trader/r-trader-offer-rule-table.vue"
export default component.exports